import { render, staticRenderFns } from "./BgHeader.vue?vue&type=template&id=0d5c355a"
import script from "./BgHeader.vue?vue&type=script&lang=js"
export * from "./BgHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports